module.exports = __webpack_public_path__ + "img/weddings_20_V.2ba677c8.webp";